import React, { memo, useMemo } from 'react';

import { NumbersConcealer } from 'common/components';

import { FIAT_MAX_FRACTION } from 'common/constants/fractions.constants';
import { localizeNumber } from 'common/helpers';
import { useBowser, useCustomer, useI18n } from 'common/hooks';

const AvailableForWithdrawal: React.FC<React.PropsWithChildren> = () => {
  const { translate } = useI18n();
  const { isMobile } = useBowser();
  const {
    balance: { availableWithdrawalBalanceUsd, creditBalanceUsd },
  } = useCustomer();

  const creditFuncdsLabel = useMemo(() => <span data-test='credit-funds-label'>{translate.toText('mobile:wallets:page:credit')}</span>, [translate]);
  const creditFuncdsBalance = useMemo(() => (
    <span data-test='credit-funds-balance'>
          <NumbersConcealer>
            $ {localizeNumber(creditBalanceUsd, { maxDigits: FIAT_MAX_FRACTION })}
          </NumbersConcealer>
        </span>
  ), [creditBalanceUsd]);

  if (!creditBalanceUsd || creditBalanceUsd < 0) return null;

  if (isMobile)
    return (
      <span className='Body2_light_12 text-white'>
        {creditFuncdsLabel}{' '}
        {creditFuncdsBalance}
      </span>
    );

  return (
    <ul className='header-bottom'>
      <li className='header-bottom__item'>
        {creditFuncdsLabel}{' '}
        {creditFuncdsBalance}
      </li>
      <li className='header-bottom__item'>
        <span data-test='available-for-withdrawal-label'>{translate.toText('mobile:wallet:mobile-sheet:available-for-withdrawal')}</span>
          <span data-test='available-for-withdrawal-balance'>
            <NumbersConcealer>
                ${' '}
                {localizeNumber((availableWithdrawalBalanceUsd ?? 0) < 0 ? 0 : availableWithdrawalBalanceUsd, {
                  maxDigits: FIAT_MAX_FRACTION,
                })}
            </NumbersConcealer>
          </span>
      </li>
    </ul>
  );
};

export default memo(AvailableForWithdrawal);
